import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer({ t }) {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <Link to="/" onClick={scrollToTop} className="footer-logo-link" aria-label="Retour à l'accueil">
            <img
              src="/images/logo/dplogofooter.webp"
              alt="Daniela Parito Architecture logo"
              className="footer-logo"
              width="144"
              height="96"
              loading="lazy"
            />
          </Link>
          <p className="footer-tagline">
            {t.agency.tagline}
          </p>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-title">Contact</h4>
          <div className="footer-links">
            <p className="footer-text">
              663 Rue du pré aux clercs<br />
              34000 Montpellier, France
            </p>
            <a href="tel:+33614902513" className="footer-link">
              06 14 90 25 13
            </a>
            <a href="mailto:daniela.parito@gmail.com" className="footer-link">
              daniela.parito@gmail.com
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-title">Navigation</h4>
          <div className="footer-links">
            <Link to="/" onClick={scrollToTop} className="footer-link">
              {t.nav.home}
            </Link>
            <Link to="/agency" onClick={scrollToTop} className="footer-link">
              {t.nav.agency}
            </Link>
            <Link to="/projects" onClick={scrollToTop} className="footer-link">
              {t.nav.projects}
            </Link>
            <Link to="/missions" onClick={scrollToTop} className="footer-link">
              {t.nav.missions}
            </Link>
            <Link to="/contact" onClick={scrollToTop} className="footer-link">
              {t.nav.contact}
            </Link>
            <Link to="/news" onClick={scrollToTop} className="footer-link">
              {t.nav.news}
            </Link>
            <Link to="/faq" onClick={scrollToTop} className="footer-link">
              FAQ
            </Link>
          </div>
        </div>
        <div className="footer-section footer-cities">
          <h4 className="footer-title">Nos zones d'intervention</h4>
          <div className="footer-links footer-cities-grid">
            <Link to="/architecte-beziers" onClick={scrollToTop} className="footer-link">Architecte Béziers</Link>
            <Link to="/architecte-sete" onClick={scrollToTop} className="footer-link">Architecte Sète</Link>
            <Link to="/architecte-agde" onClick={scrollToTop} className="footer-link">Architecte Agde</Link>
            <Link to="/architecte-lunel" onClick={scrollToTop} className="footer-link">Architecte Lunel</Link>
            <Link to="/architecte-frontignan" onClick={scrollToTop} className="footer-link">Architecte Frontignan</Link>
            <Link to="/architecte-mauguio" onClick={scrollToTop} className="footer-link">Architecte Mauguio</Link>
            <Link to="/architecte-lattes" onClick={scrollToTop} className="footer-link">Architecte Lattes</Link>
            <Link to="/architecte-castelnau-le-lez" onClick={scrollToTop} className="footer-link">Architecte Castelnau</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Daniela Parito Architecture. Tous droits réservés.
            Site conçu par <a href='https://sdr-web.fr'><span className='footer-sdr'>SDR Web</span></a>.
          </p>
          <div className="footer-legal-links">
            <Link to="/legal-notice" onClick={scrollToTop} className="footer-legal-link">
              Mentions légales
            </Link>
            <span className="footer-separator">•</span>
            <Link to="/privacy-policy" onClick={scrollToTop} className="footer-legal-link">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}